// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IAddressInfoDto } from './IAddressInfoDto';
import {
    IAddressInfoDtoFromJSON,
    IAddressInfoDtoFromJSONTyped,
    IAddressInfoDtoToJSON,
    IAddressInfoDtoToJSONTyped,
} from './IAddressInfoDto';

/**
 * 
 * @export
 * @interface IMatchEmployeeAggregatorDto
 */
export interface IMatchEmployeeAggregatorDto {
    /**
     * 
     * @type {number}
     * @memberof IMatchEmployeeAggregatorDto
     */
    employee_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IMatchEmployeeAggregatorDto
     */
    employee_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IMatchEmployeeAggregatorDto
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IMatchEmployeeAggregatorDto
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IMatchEmployeeAggregatorDto
     */
    ssn?: string;
    /**
     * 
     * @type {string}
     * @memberof IMatchEmployeeAggregatorDto
     */
    birth_date?: string;
    /**
     * 
     * @type {string}
     * @memberof IMatchEmployeeAggregatorDto
     */
    employment_status?: IMatchEmployeeAggregatorDtoEmploymentStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof IMatchEmployeeAggregatorDto
     */
    organization_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IMatchEmployeeAggregatorDto
     */
    organization_name?: string;
    /**
     * 
     * @type {number}
     * @memberof IMatchEmployeeAggregatorDto
     */
    account_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IMatchEmployeeAggregatorDto
     */
    account_number?: string;
    /**
     * 
     * @type {number}
     * @memberof IMatchEmployeeAggregatorDto
     */
    available_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IMatchEmployeeAggregatorDto
     */
    investments_balance?: number;
    /**
     * 
     * @type {string}
     * @memberof IMatchEmployeeAggregatorDto
     */
    account_status?: IMatchEmployeeAggregatorDtoAccountStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof IMatchEmployeeAggregatorDto
     */
    investment_status?: IMatchEmployeeAggregatorDtoInvestmentStatusEnum;
    /**
     * 
     * @type {IAddressInfoDto}
     * @memberof IMatchEmployeeAggregatorDto
     */
    mailing_address?: IAddressInfoDto;
}

/**
* @export
* @enum {string}
*/
export enum IMatchEmployeeAggregatorDtoEmploymentStatusEnum {
    A = 'A',
    T = 'T',
    L = 'L',
    R = 'R',
    F = 'F',
    C = 'C'
}
/**
* @export
* @enum {string}
*/
export enum IMatchEmployeeAggregatorDtoAccountStatusEnum {
    OPEN = 'OPEN',
    CLOSED = 'CLOSED',
    PENDING_CLOSED = 'PENDING_CLOSED',
    FROZEN = 'FROZEN',
    PENDING = 'PENDING'
}
/**
* @export
* @enum {string}
*/
export enum IMatchEmployeeAggregatorDtoInvestmentStatusEnum {
    INVESTOR_CREATED = 'INVESTOR_CREATED',
    INVESTMENT_PATH_SELECTED = 'INVESTMENT_PATH_SELECTED',
    QUESTIONNAIRE_FILLED = 'QUESTIONNAIRE_FILLED',
    INVESTMENT_AMOUNT_SELECTED = 'INVESTMENT_AMOUNT_SELECTED',
    PENDING_EXTERNAL_CREATION = 'PENDING_EXTERNAL_CREATION',
    ACTIVE = 'ACTIVE'
}


/**
 * Check if a given object implements the IMatchEmployeeAggregatorDto interface.
 */
export function instanceOfIMatchEmployeeAggregatorDto(value: object): value is IMatchEmployeeAggregatorDto {
    return true;
}

export function IMatchEmployeeAggregatorDtoFromJSON(json: any): IMatchEmployeeAggregatorDto {
    return IMatchEmployeeAggregatorDtoFromJSONTyped(json, false);
}

export function IMatchEmployeeAggregatorDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IMatchEmployeeAggregatorDto {
    if (json == null) {
        return json;
    }
    return {
        
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'employee_name': json['employee_name'] == null ? undefined : json['employee_name'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'ssn': json['ssn'] == null ? undefined : json['ssn'],
        'birth_date': json['birth_date'] == null ? undefined : json['birth_date'],
        'employment_status': json['employment_status'] == null ? undefined : json['employment_status'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'organization_name': json['organization_name'] == null ? undefined : json['organization_name'],
        'account_id': json['account_id'] == null ? undefined : json['account_id'],
        'account_number': json['account_number'] == null ? undefined : json['account_number'],
        'available_amount': json['available_amount'] == null ? undefined : json['available_amount'],
        'investments_balance': json['investments_balance'] == null ? undefined : json['investments_balance'],
        'account_status': json['account_status'] == null ? undefined : json['account_status'],
        'investment_status': json['investment_status'] == null ? undefined : json['investment_status'],
        'mailing_address': json['mailing_address'] == null ? undefined : IAddressInfoDtoFromJSON(json['mailing_address']),
    };
}

export function IMatchEmployeeAggregatorDtoToJSON(json: any): IMatchEmployeeAggregatorDto {
    return IMatchEmployeeAggregatorDtoToJSONTyped(json, false);
}

export function IMatchEmployeeAggregatorDtoToJSONTyped(value?: IMatchEmployeeAggregatorDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employee_id': value['employee_id'],
        'employee_name': value['employee_name'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'ssn': value['ssn'],
        'birth_date': value['birth_date'],
        'employment_status': value['employment_status'],
        'organization_id': value['organization_id'],
        'organization_name': value['organization_name'],
        'account_id': value['account_id'],
        'account_number': value['account_number'],
        'available_amount': value['available_amount'],
        'investments_balance': value['investments_balance'],
        'account_status': value['account_status'],
        'investment_status': value['investment_status'],
        'mailing_address': IAddressInfoDtoToJSON(value['mailing_address']),
    };
}

